import React from 'react';
import NuestrosServ from '../components/NuestrosServ';

function OurServices() {
    return (
        <>
            <NuestrosServ />
        </>
    );
}

export default OurServices;
